import { Button, ButtonColor } from '@vista-digital/occ-ui'
import React from 'react'
import { GridElement } from '..'
import { CmsLinkComponent } from '../../feComponents/cmsLink/CmsLink'

import './cta-button.scss'

export const CtaButton: React.FC<GridElement> = props => {
    const { link, color, text, position } = props.value

    // Hide link name, use text value in button label for button text
    link[0].name = ''

    return (
        <div className={'cta-button ' + position}>
            <CmsLinkComponent link={link[0]}>
                <Button color={ButtonColor[color[0]]} label={text} />
            </CmsLinkComponent>
        </div>
    )
}
